module.exports = __webpack_public_path__ + "bbd2b0e41c47cb809a4d8e6e7a2648e3.png";